import Alert from "@mui/material/Alert";
import React from "react";

/**
 *
 * @param {String} message text displayed on Alert
 * @param {Component} children component(s) to display inside Alert (optional)
 * @param {*} *** see commonProps for other props that can be injected into Alerts
 * @returns a default styled Alert
 */
const StyledAlert = (props) => {
  const commonProps = {
    severity: props.severity ? props.severity : "info",
    action: props.action ? props.action : null,
    onClose: props.onClose ? props.onClose : null,
    variant: props.variant ? props.variant : "standard",
    sx: {
      fontSize: props.fontSize ? props.fontSize : 14,
      width: props.width ? props.width : "auto",
      height: props.height ? props.height : "auto",
      margin: props.margin ? props.margin : "auto",
      marginTop: props.marginTop ? props.marginTop : "auto",
      marginBottom: props.marginBottom ? props.marginBottom : "auto",
      marginLeft: props.marginLeft ? props.marginLeft : "auto",
      marginRight: props.marginRight ? props.marginRight : "auto",
    },
  };
  if (props.children) {
    return <Alert {...commonProps} children={props.children} />;
  } else {
    return <Alert {...commonProps}>{props.message}</Alert>;
  }
};

export default StyledAlert;
